module.exports = __webpack_public_path__ + "static/media/16UNODC34.fb8de076.jpg";